import React from 'react';
import { BsCaretDownFill, BsCaretRightFill } from "react-icons/bs";
import { FaBox, FaCubes, FaConciergeBell, FaCheckCircle } from "react-icons/fa";

const ProductsKPI = ({ 
  totalProducts, 
  consumibles, 
  services, 
  activeProducts,
  showKPIs,
  setShowKPIs 
}) => {
  const formatNumber = (value) => {
    if (typeof value === 'number') {
      return value.toLocaleString();
    }
    return value;
  };

  const kpiCards = [
    { 
      title: 'Total Products', 
      value: totalProducts,
      icon: <FaBox />, 
      iconColor: '#E4E4FF'
    },
    { 
      title: 'Consumibles', 
      value: consumibles,
      icon: <FaCubes />, 
      iconColor: '#e8f5e8'
    },
    { 
      title: 'Services', 
      value: services,
      icon: <FaConciergeBell />, 
      iconColor: '#e8f4fd'
    },
    { 
      title: 'Active Products', 
      value: activeProducts,
      icon: <FaCheckCircle />, 
      iconColor: '#fde8f4'
    }
  ];

  return (
    <>
      {showKPIs && (
        <div className="row gy-3 introbx_row mb-4">
          {kpiCards.map((kpi, index) => (
            <div key={index} className="col">
              <div className="d-flex align-items-center gap-2 p-3 rounded-10 shadow-sm">
                <div className="icon flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '2rem', height: '2rem', backgroundColor: '#E4E4FF', color: '#8381FF' }}>
                  <span className="d-block material-symbols-outlined fs-lg">{kpi.icon}</span>
                </div>
                <div className="info flex-fill">
                  <p className="fs-sm text-gray mb-0">{kpi.title}</p>
                  <p className="lh-1 fw-semibold">{formatNumber(kpi.value)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ProductsKPI;